module.exports = __webpack_public_path__ + "images/ExternalPromo/weebly-378895-728_90.gif?6de05";